import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AddincometypeComponent } from '../../incometype/addincometype/addincometype.component';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AddicomedetailComponent } from '../addicomedetail/addicomedetail.component';
@Component({
  selector: 'app-addincome',
  templateUrl: './addincome.component.html',
  styleUrls: ['./addincome.component.css']
})
export class AddincomeComponent implements OnInit, ComponentCanDeactivate {
  [x: string]: any;

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  ispartyaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  incomemainColl: any = [];

  incomeBO: any = {}
  partyColl: any = [];
  paymenttermsColl: any = [];
  paymentmodeColl: any = [];

  incomedetailscoll: any = [];

  ismanualclose: boolean;

  isincometypeaddmode: boolean = false;

  incometypeColl: any = [];

  totalamount: number = 0;


  discounttype: string = "";

 
 
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  incomeform = new FormGroup({
    incomeid: new FormControl(0),
    incomeno: new FormControl('', Validators.required),
    incomedate: new FormControl(null, Validators.required),
    incomeamt: new FormControl(null),
    description: new FormControl(''),
    refno: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Income";

  gridfocusrow: number = -1;

  @Input() incomeid: number = 0
  @Input() filterpartyid: number =null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() ptype: String = "C";
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.currencyMask=this.loginService.fngetDecimalPlaces()

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.incomeform.reset();
      this.fnInitializeForm();

      if (this.incomeid > 0) {
        this.fngetIncome();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fnGetParty();
      this.fnGetIncomeType();

    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }




  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.incomeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isincometypeaddmode = this.loginService.fnCheckUserRoleAction("Incometype", 'CREATE')
    this.ispartyaddmode = this.loginService.fnCheckUserRoleAction("Supplier", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.incomeform.setValue({
      incomeid: 0,
      incomeno: 'NEW',
      incomedate: new Date(),
      incomeamt: null,
      description: null,
      refno: '',
      inactive: false,
    })
  }

  //Get 
  fngetIncome() {
   
    var data = {
      'incomeid': this.incomeid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getIncome(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.incomemainColl = result[0];

          var editdata = this.incomemainColl[0];
          this.incomeBO = editdata;
          this.fnEditMode(editdata);

          this.incomedetailscoll = result[1];
          //console.log(this.incomedetailscoll)

          if (this.incomedetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcsSummaryTotal();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.incomedetailscoll) {
      if (row.incometypeid > 0) {
        _detailscheck = true;
      }
    }

    if (!_detailscheck) {
      this.errtxt = "Income Details cannot be empty"
      this.incomeform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      for (let row of this.incomedetailscoll) {

        if (row.incometypeid > 0 && this.loginService.fnCheckZeroDetcimal(row.amount) === 0) {
          this.errtxt = "Amount is cannot be empty"
          this.incomeform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.incomeform.get('inactive')) {
      this.incomeform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.incomeform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'incomeid': this.incomeid,
          'incomeno': this.incomeform.get('incomeno').value,
          'incomedate': this.fnFormatDatetime(this.incomeform.get('incomedate').value),
          'incomeamt': this.incomeform.get('incomeamt').value,
          'description': this.incomeform.get('description').value,
          'refno': this.incomeform.get('refno').value,
          'inactive': this.incomeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'incomedetailscoll': this.incomedetailscoll,
        }

        if (this.incomeform.get('incomeid').value > 0) {

          this.fnSetIncome(data);
        }
        else {

          this.fnInsertIncome(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertIncome(data) {

    this.appService.fnInsertIncome(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Income has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.incomeno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].incomeid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetIncome(data) {

    this.appService.fnSetIncome(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Income has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.incomeid, data.incomeno);

          this.fnEditFormEdit(this.incomeid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.incomedate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.incomedate));


    this.incomeform.setValue({

      incomeid: deptBO.incomeid,
      incomeno: deptBO.incomeno,
      incomedate: deptBO.incomedate,
      incomeamt: deptBO.incomeamt,
      description: deptBO.description,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.incomeid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetIncomeType() {
    this.isLoadingResult = true;

    var data = {
      'incometypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getIncometype(data)
      .subscribe(
        (res) => {
          this.incometypeColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadIncomeType(index) {
  

    var data = {
      'incometypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),

    }
    this.appService.getIncometype(data)
      .subscribe(
        (res) => {
          this.fnChangeIncomeType(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnGetParty() {
    var data = {
      'partyid': 0,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnChangeIncomeType(index) {

    var _incometypename = "", _partyid = 0;

    for (let abo of this.incometypeColl) {
      if (this.incomedetailscoll[index].incometypeid === abo.incometypeid) {
        _incometypename = abo.incometypename;
      }
    }
    this.incomedetailscoll[index].incometypename = _incometypename;
  }
  fnChangeParty(index) {

    var _partyname = "";

    for (let abo of this.partyColl) {
      if (this.incomedetailscoll[index].partyid === abo.partyid) {
        _partyname = abo.partyname;
      }
    }
    this.incomedetailscoll[index].partyname = _partyname;
  }


  fnCalcDetails() {

    for (let row of this.incomedetailscoll) {
      row.subtotal = row.qty * row.unitprice;
      this.subtotal = this.subtotal + Number(row.subtotal)

   
  
    }
    this.fnCalcsSummaryTotal()
  }




  fnCalcsSummaryTotal() {
   
    this.totalamount = 0;


    for (let row of this.incomedetailscoll) {
    
      this.totalamount = Number(this.fnConvertDecimal(this.totalamount)) + Number(this.fnConvertDecimal(row.amount))
    }
    this.incomeform.patchValue({ incomeamt: this.totalamount })
  }




  fnDeleteIncomeConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.incomedetailscoll.splice(index, 1)
            if (this.incomedetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
           // this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  // fnChangeRawmaterial(index) {

  //   var _prodname = "", _unitprice = 0;

  //   for (let abo of this.rawmaterialColl) {
  //     if (this.incomedetailscoll[index].rawmaterialid === abo.rawmaterialid) {
  //       _prodname = abo.rawmaterialname;
  //       _unitprice = abo.incomeprice;
     
     
  //     }
  //   }
  //   this.incomedetailscoll[index].rawmaterialname = _prodname;
  //   this.incomedetailscoll[index].unitprice = _unitprice;

    

  // }


  fnSetFirstRowItem() {
    if (this.incomedetailscoll.length > 0) {
      if (!this.incomedetailscoll[this.incomedetailscoll.length - 1].incometypeid) {
        return
      }
    }

    var data = {
      incomedetailsid: 0,
      incomeid: 0,
      incometypeid: null,
      incometypename: '',
      partyid: null,
      partyname: '',
      descr: '',
      amount: 0,

    }

    this.incomedetailscoll.push(data)
    //console.log(this.incomedetailscoll)

  }



  fnGetFirstRowItem() {

    var data = {
      incomedetailsid: null,
      incomeid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: null,
      unitprice: null,
      subtotal: null,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal: null
    }

    return data;

  }

  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index
 
  }

  fnSetNextFocus(index) {

    if (this.incomedetailscoll.length > 0) {

      if (this.incomedetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //AddParty
  private fnAddParty() {

    const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l' });
    modalRef.componentInstance.ptype = this.ptype

    if (modalRef.componentInstance.ptype === 'C') {
      modalRef.componentInstance.formname = 'Customer'
    }
    else if (modalRef.componentInstance.ptype === 'S') {
      modalRef.componentInstance.formname = 'Supplier'
    }
    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetParty();

      if (receivedEntry > 0) {
        this.incomeform.patchValue({ partyid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddIncomeType(index) {

    const modalRef = this.productFindService.open(AddincometypeComponent, { size: <any>'m' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetIncomeType();

      if (receivedEntry > 0) {
        this.incomedetailscoll[index].incometypeid = receivedEntry
      }
      this.fnReLoadIncomeType(index);

    });
  }
  //Print
  // private fnPrintincome() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.incomeid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.incomeid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnAddIncomeDetails() {

    const modalRef = this.productFindService.open(AddicomedetailComponent, { size: <any>'l' });
    modalRef.componentInstance.expensedetailsBO=this.fnGetFirstRowItem()
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry.checkstatus === "DONE") {
        this.fnSetFirstRowItem()
        this.incomedetailscoll[this.incomedetailscoll.length - 1] = receivedEntry.data;
        this.fnCalcDetails()
      }

    });
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
